import api from '@/api/api.js'

export default {
    pending(patientId) {
        return api.comptabilite().get('/references-internes/en-attente', {
            params: { patient_id: patientId }
        }).then(response => response.data)
    },
    validate(referenceId, patientId, numBonSociete) {
        return api.comptabilite().post(`/references-internes/${referenceId}/valider`, {
            patient_id: patientId,
            num_bon_societe: numBonSociete || null
        }).then(response => response.data)
    }
}
